import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData, getFile, postFile } from "features/dinamic";
import { fetchFacilitadorSesion } from "features/Facilitador/facilitadorSesionSlice";
import { setLoading } from "features/loader";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import saveAs from "file-saver";


interface GrupoSesionState {
    status: string;
    error: string;
    grupoSesionList: any[],
    grupoSesion: {
        idGrupoSesion: number | null;
        urlGrabacion: string | null;
        observaciones: string | null;
        titulo: string | null;
        fileUrl: string | null;
        fileImage: string | null;
        fileData1: string | null;
        fileData2: string | null;
    }

}

const initialState: GrupoSesionState = {
    status: "",
    error: "",
    grupoSesionList: [],
    grupoSesion: {
        idGrupoSesion: null,
        urlGrabacion: null,
        observaciones: null,
        titulo: null,
        fileUrl: null,
        fileImage: null,
        fileData1: null,
        fileData2: null
    }
}

export const fetchGrupoSesion = createAsyncThunk('fetchGrupoSesion', async ({ idGrupoSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 114;
    const { result, message, data } = await getData({ idsp, idGrupoSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const downloadGrupoSesion = createAsyncThunk('downloadGrupoSesion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const grupoSesionNew = selectGrupoSesion(state);
    const grupoSesionAttributes = { ...grupoSesionNew };
    let alert: AlertInterface;
    if (grupoSesionAttributes.fileUrl) {
        const fileExtension = grupoSesionAttributes.fileUrl.substring(grupoSesionAttributes.fileUrl.lastIndexOf('.'));
        const fileName = `${grupoSesionAttributes.titulo}${fileExtension}`;
        const response = await getFile({ fileUrl: grupoSesionAttributes.fileUrl, fileName: fileName });

        if (response && response.blob) {
            saveAs(response.blob, fileName);
            alert = { title: 'CORRECTO..!', message: "RECURSO DESCARGADO CORRECTAMENTE", data: [], type: 'LimeGreen', time: Date.now() };
        } else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: "RECURSO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
        }
    } else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: "RECURSO NO DISPONIBLE", data: [], type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
});

export const saveEvidencia = createAsyncThunk('saveEvidencia', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const grupoSesionNew = selectGrupoSesion(state);
    const grupoSesionAttributes = { ...grupoSesionNew };
    const idsp = 116;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...grupoSesionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (grupoSesionAttributes.idGrupoSesion && grupoSesionAttributes.fileData1 !== null && grupoSesionAttributes.fileData1 !== '') {
            const { result: resultFile } = await postFile({ idsp: 117, id: grupoSesionAttributes.idGrupoSesion, dir: "gruposesion", fileData: grupoSesionAttributes.fileData1, fileName: `1${grupoSesionAttributes.idGrupoSesion}` }, getState, dispatch);
            if (resultFile) {
                if (grupoSesionAttributes.idGrupoSesion && grupoSesionAttributes.fileData2 !== null && grupoSesionAttributes.fileData2 !== '') {
                    const { result: resultFile2 } = await postFile({ idsp: 118, id: grupoSesionAttributes.idGrupoSesion, dir: "gruposesion", fileData: grupoSesionAttributes.fileData2, fileName: `2${grupoSesionAttributes.idGrupoSesion}` }, getState, dispatch);
                    if (!resultFile2 || !resultFile) {
                        alert = { title: 'ACCIÓN INCOMPLETA', message: "IMAGEN NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
                    }
                }
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    if (result) {
        dispatch(fetchGrupoSesion({ idGrupoSesion: grupoSesionAttributes.idGrupoSesion }));
        dispatch(fetchFacilitadorSesion({ idGrupoSesion: grupoSesionAttributes.idGrupoSesion }));
    }
    return rejectWithValue(message);
});


export const grupoSesionSlice = createSlice({
    name: 'grupoSesion',
    initialState,
    reducers: {
        setGrupoSesionList: (state, action) => {
            state.grupoSesionList = action.payload;
        },
        setGrupoSesion: (state, action) => {
            state.grupoSesion = !action.payload ? initialState.grupoSesion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGrupoSesion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGrupoSesion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.grupoSesionList = data ? data : [];

            })
            .addCase(fetchGrupoSesion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectGrupoSesionList = (state: RootState) => state.grupoSesion.grupoSesionList;
export const selectGrupoSesion = (state: RootState) => state.grupoSesion.grupoSesion;

export const { setGrupoSesionList, setGrupoSesion } = grupoSesionSlice.actions;

export default grupoSesionSlice.reducer;
